import { createApp } from "vue"
import "./style.css"
import App from "./App.vue"
import { createProvider } from "./vue-apollo"
import { createPinia } from "pinia"
import { createVfm } from "vue-final-modal"
import "vue-final-modal/style.css"
import { getRouter } from "./router/router"
import VueNumber from "vue-number-animation"
import Toaster from "@meforma/vue-toaster"
import * as Sentry from "@sentry/vue";

import { registerGlobalComponents } from "@/globalComponents"

import { OhVueIcon } from "oh-vue-icons"
import { registerIcons } from "@/config/icons"
import "vue-final-modal/style.css"
import "viewerjs/dist/viewer.css"
import VueViewer from "v-viewer"

// Register all application icons
registerIcons()

VueViewer.setDefaults({
  button: false,
  navbar: false,
  title: false,
  toolbar: false,
  tooltip: false,
  movable: false,
  zoomable: false,
  rotatable: false,
  scalable: false,
  transition: true,
  fullscreen: true,
  keyboard: true,
  url: "data-source",
})

const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://2167ad96b5024e142abce804a7a3fc1a@o208147.ingest.us.sentry.io/4509870674673664",
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const pinia = createPinia()
const vfm = createVfm()



app.use(createProvider())
app.use(getRouter())
app.use(vfm)
app.use(VueNumber)
app.use(Toaster)
app.use(VueViewer)

registerGlobalComponents(app)

app.use(pinia)
app.component("v-icon", OhVueIcon)
app.mount("#app")
